import * as dateFns from 'date-fns';

export const startOfTodayLocal = dateFns.startOfToday;
export const addDays = dateFns.addDays;
export const format = dateFns.format;
export const isValid = dateFns.isValid;
export const parse = dateFns.parse;
export const parseISO = dateFns.parseISO;

const ISO_FORMAT = 'yyyy-MM-dd';
const BR_DISPLAY_FORMAT = 'dd/MM/yyyy';

const DATE_ONLY_YMD = /^\d{4}-\d{2}-\d{2}$/;

/** Converte qualquer ISO aceito (`yyyy-MM-dd` ou ISO 8601 com hora/timezone) para `yyyy-MM-dd`. */
export function normalizeIsoToYyyyMmDd(iso: string): string {
  const trimmed = iso.trim();
  if (!trimmed) return '';
  if (DATE_ONLY_YMD.test(trimmed)) {
    const d = parse(trimmed, ISO_FORMAT, new Date());
    return isValid(d) ? trimmed : '';
  }
  const d = parseISO(trimmed);
  if (!isValid(d)) return '';
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Converte qualquer ISO aceito (`yyyy-MM-dd` ou ISO 8601 com hora/timezone) para `dd/MM/yyyy`. */
export function isoToBrDisplay(iso: string | undefined): string {
  if (!iso?.trim()) return '';
  const trimmed = iso.trim();
  if (DATE_ONLY_YMD.test(trimmed)) {
    const d = parse(trimmed, ISO_FORMAT, new Date());
    return isValid(d) ? format(d, BR_DISPLAY_FORMAT) : '';
  }
  const d = parseISO(trimmed);
  if (!isValid(d)) return '';
  const cal = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  return format(cal, BR_DISPLAY_FORMAT);
}

export function brDisplayToIso(display: string): string {
  if (!display || display.replace(/\D/g, '').length < 8) return '';
  const d = parse(display, BR_DISPLAY_FORMAT, new Date());
  return isValid(d) ? format(d, ISO_FORMAT) : '';
}
